// Dependencies
import { camelCase, snakeCase, isObject } from 'lodash'

export class ConvertUtility {

  static key(input, pattern = 'camel') {
    
    let result = input
    
    const isArray = Array.isArray(input)

    if (typeof input !== 'object' && !isArray) return input

    if (input instanceof Date) return input

    const maker = (key, keyPattern) => {
      if (keyPattern === 'camel') return camelCase(key)
      if (keyPattern === 'snake') return snakeCase(key)
      return key
    }

    const mapper = (data, key) => {

      const mapped = { ...data }

      const mapKey = maker(key, pattern)
      
      const mapValue = ConvertUtility.key(
        (input)[key], pattern
      )

      mapped[mapKey] = mapValue

      return mapped
    }

    if (isArray) {

      result = input.map(
        (item) => ConvertUtility.key(item, pattern)
      )
    }
    else if (isObject(input)) {
      
      result = Object
        .keys(input)
        .reduce(mapper, {})
    }

    return result
  }
}
